import {
  useEmailSenderValidationStatus,
  useGetEntityPreferencesByPath,
} from "./entity";
import { isReservedSenderDomain } from "../utils/emailSender";

export type SenderEmailGate = {
  canSend: boolean;
  isDefault: boolean;
  isUnverified: boolean;
  senderEmail: string;
  isLoading: boolean;
  reason: "default" | "unverified" | null;
};

export const useSenderEmailGate = (
  customer_identification: string,
  entity_identification: string,
  options?: { enabled?: boolean }
): SenderEmailGate => {
  const enabled = options?.enabled ?? true;

  const { data: entityPreferences, isLoading: isPrefsLoading } =
    useGetEntityPreferencesByPath(
      customer_identification,
      entity_identification,
      "email_address_sender",
      {
        enabled:
          enabled && !!customer_identification && !!entity_identification,
      }
    );

  const { data: validationStatus, isLoading: isStatusLoading } =
    useEmailSenderValidationStatus(
      customer_identification,
      entity_identification,
      {
        enabled:
          enabled && !!customer_identification && !!entity_identification,
      }
    );

  const senderEmail = (
    entityPreferences?.email_address_sender ?? ""
  ).toLowerCase();

  const isDefault = isReservedSenderDomain(senderEmail);

  const isUnverified =
    !!senderEmail &&
    !isDefault &&
    (!validationStatus ||
      validationStatus.is_valid !== true ||
      (validationStatus.email || "").toLowerCase() !== senderEmail);

  const isLoading = isPrefsLoading || isStatusLoading;

  const reason: SenderEmailGate["reason"] = isDefault
    ? "default"
    : isUnverified
    ? "unverified"
    : null;

  return {
    canSend: !isDefault && !isUnverified,
    isDefault,
    isUnverified,
    senderEmail,
    isLoading,
    reason,
  };
};
